var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-wrapper"},[_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',{attrs:{"include":"StatusMeter"}},[_c('router-view',{attrs:{"name":"sidebar"}})],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ab96dd06","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-svg-inline-loader/dist/index.min.js??ref--6!./src/components/views/game/Sidebar.vue
// module id = null
// module chunks = 